export default "__VITE_ASSET__32248517__"